import { RootState } from '@/store/Reducer'

export const selectItalyFiscalCodesManagement = (state: RootState) => state.italyFiscalCodesManagement
